// extracted by mini-css-extract-plugin
export default {"container_full":"rR94ehXLlkMBoclmBnCb","container":"SvPr1oQf_FOZl4tHKnrE","card":"R5H9R7jcSMjTUbf9SOzA"};